export default function calculatePercentages(data: { key: string; value: number }[]) {
    const total = data.map(({ value }) => value).reduce((acc, curr) => acc + curr, 0)
    return data.map(({ value }) => Math.round((value / total) * 100))
}
